import { useAuth0 } from "@auth0/auth0-react";
import { RiUser3Line } from "react-icons/ri";
import { useState } from "react";

const AppBar = () => {
  const { user, isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="flex justify-end items-center p-4 w-full bg-amber-100 pl-20">
      <div className="relative">
        {!isAuthenticated ? (
          <button
            onClick={() => loginWithRedirect()}
            className="underline py-2 px-2 rounded text-blue-800"
          >
            login
          </button>
        ) : (
          <>
            <button
              onClick={toggleDropdown}
              className="flex items-center space-x-2 py-2 px-3 rounded hover:bg-amber-200 transition-colors"
            >
              <RiUser3Line className="text-xl" />
              <span>{user?.name}</span>
            </button>

            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  Logout
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AppBar;
